import React, { Component } from 'react';
import './VideoBox.css';
import i18n from 'i18next';

export default class VideoBox extends Component<any, any> {

  video: any;

  constructor(props: any) {
    super(props);
    this.video = React.createRef();
    this.state = {
    }
  }
  componentDidMount() {
    this.video.current.setAttribute('controls', 'controls');
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.video !== nextProps.video) {
      if (this.state.playing) {
        this.video.current.pause();
        this.setState({ playing: undefined });
      }
      // this.video.current.load();
    }
  }

  componentDidUpdate() {
  }

  renderCurrencyRow() {
    if (this.props.ccy) {
      return <div className='VideoBox-Currency'>{i18n.t('Common.' + this.props.ccy)}</div>;
    }
  }

  clickOnVideo = (e: any) => {
    if (!this.state.playing) {
      setTimeout(() => {
        if (!this.state.playing) {
          if (this.video && this.video.current) {
            this.video.current.play();
          }
        }
      }, 300);
    }
  }

  onPlayHandler = (e: any) => {
    this.setState({ playing: true });
  }

  onPauseHandler = (e: any) => {
    this.setState({ playing: undefined });
  }

  renderVideoMask() {
    if (!this.state.playing) {
      return <div className='VideoBox-Video-Mask' onClick={this.clickOnVideo}></div>;
    }
  }

  render() {
    return (
      <div className="VideoBox">
        {this.renderCurrencyRow()}
        <div className='VideoBox-Category'>{this.props.category}</div>
        <div className='VideoBox-Title' style={this.props.style}>{this.props.title}</div>
        <div className='VideoBox-Video'>
          <video preload="none" width='100%' webkit-playsinline='' playsInline ref={this.video} poster={this.props.thumbnail} onPlay={this.onPlayHandler} onPause={this.onPauseHandler}>
            {/* <video width='100%' controls playsInline ref={this.video} style={{background: 'transparent no-repeat url(\'' + this.props.thumbnail + '\')', backgroundSize: '100%'}}> */}
            <source src={this.props.video} type="video/mp4"></source>
          </video>
          {this.renderVideoMask()}
        </div>
        <div className='VideoBox-Desc'>
          <div className='VideoBox-Desc-Header'>
            <div className='VideoBox-Desc-Header-Speaker'>{this.props.speaker}</div>
            <div className='VideoBox-Desc-Header-Lang'>{this.props.lang}</div>
          </div>
          <div className='VideoBox-Desc-Content' dangerouslySetInnerHTML={{ __html: this.props.content }}></div>
          <div className='VideoBox-Desc-Date'>{this.props.date}</div>
        </div>
      </div>
    );
  }
}
